import { Controller } from "@hotwired/stimulus"

// The "Primary only" filter narrows to accounts where the selected staff
// member holds the Primary tag for a role, so it needs a role to mean
// anything. Keep it disabled (and unchecked) until one is chosen.
export default class extends Controller {
  static targets = ["roleSelect", "toggle", "toggleLabel"]

  connect() {
    this.roleChanged()
  }

  roleChanged() {
    if (!this.hasToggleTarget || !this.hasRoleSelectTarget) return

    const roleChosen = this.roleSelectTarget.value !== ""
    this.toggleTarget.disabled = !roleChosen
    if (!roleChosen) this.toggleTarget.checked = false

    if (this.hasToggleLabelTarget) {
      this.toggleLabelTarget.title = roleChosen
        ? "Only accounts where the selected staff member holds the Primary tag for this role"
        : "Choose a role first"
    }
  }
}
